export default __webpack_public_path__ + "static/media/bronze.eb6713a8.svg";